<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-account-check
      </v-icon>
        <span class="pl-2">{{ $t('ops.activation.title') }}</span>
      </v-card-title>
      <v-card-text>
        <div v-html="$t('ops.activation.noteHtml')"></div>
      </v-card-text>

      <!-- text filed for activation code -->
      <v-card-text>
        <v-text-field
          v-model="activationCode"
          :label="$t('ops.activation.codeLabel')"
          outlined
          dense
          :rules="activationCodeRules"
        ></v-text-field>
      </v-card-text>

      <!-- activate button -->
      <v-card-actions>
        <v-btn
          color="primary"
          @click="activate"
          :loading="isLoading"
          :disabled="!activationCode"
        >
          {{ $t('ops.activation.activateButton') }}
        </v-btn>
      </v-card-actions>


    </v-card>
  </div>
</template>

<script>

import {
  mdiStopCircleOutline,
  mdiAccountCheck,
  mdiAccountClock,
  mdiAccountOff,
  mdiPlayCircleOutline,
  mdiTrashCan,
  mdiDeleteRestore,
  mdiAirplane,
  mdiMotionPause
} from "@mdi/js";

import { activationStore } from "@/utils/helpers";
export default {
  components: {
    
  },
  setup() {
    return { activationStore }
  },
  data() {
    return {
      activationCode: null,
      isLoading: false,
      activationCodeRules: [
        (v) => !!v || this.$t('ops.activation.codeRequired'),
      ],
      icons: {
        mdiStopCircleOutline,
        mdiAccountCheck,
        mdiAccountOff,
        mdiAccountClock,
        mdiPlayCircleOutline,
        mdiTrashCan,
        mdiDeleteRestore,
        mdiAirplane
      },
    };
  },
  mounted() {
    this.loadActivationCode();
  },
  methods: {
    loadActivationCode() {
      this.isLoading = true;
      axios
        .get(`/activation/get-activation-code`)
        .then((response) => {
          this.activationCode = response.data.secure_key;
        })
        .catch((error) => {
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    activate() {
      this.isLoading = true;
      axios
        .post(`/activation/activate`, {
          activationCode: this.activationCode,
        })
        .then((response) => {
          this.$notify({
            title: this.$t('common.success'),
            text: this.$t('ops.activation.activatedSuccess'),
            type: "success",
          });
          this.activationStore.isActivated = true;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('ops.activation.activateError'),
            type: "error",
          });
          this.activationStore.isActivated = false;
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
